import React, { createContext, useContext } from 'react';
import { useSession } from '@hooks';
import { useAuth } from './AuthContext';

/**
 * Session Context for study session management
 */
const SessionContext = createContext(null);

export function SessionProvider({ courseId, children }) {
  const { user } = useAuth();
  const sessionData = useSession(user?.id, courseId);

  const value = {
    ...sessionData,
  };

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSessionContext() {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within SessionProvider');
  }
  return context;
}
